import React, { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Menu from "@material-ui/core/Menu";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Button from "@material-ui/core/Button";
import ProfileIcon from "@material-ui/icons/AccountBox";
import { GoogleLogout } from "react-google-login";
import {
    loadLocationTitle,
} from "../redux/contextInfos/contextInfosActions";
import { clearUsers } from "../redux/users/usersActions";
import withAuth from "./withAuth";
import "./MenuAppBar.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import { getStateAccessor } from "../lib/evaluateStringAsCodeHelper.js";
import SideBar from "./SideBar";
import MenuIcon from '@material-ui/icons/Menu';
import { Fab, Hidden, Icon, IconButton, MenuItem } from "@material-ui/core";
import ExpandMore from '@material-ui/icons/ExpandMore';
import ExtranetSideBarContent from "./ExtranetSideBarContent";
import Breadcrumbs from "../containers/Layout/ExtranetBreadcrumbs";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import HomeIcon from "@material-ui/icons/Home";
import { clearHiddenHomeWidgets } from '../redux/home/homeWidgetActions'

const styles = {
    flex: {
        flex: 1,
    },
    menuButton: {
        marginLeft: -12,
        marginRight: 20,
    },
    logoutButton: {
        background: "#FE5815",
        border: "none!important",
        fontSize: "1rem!important",
        width: "auto",
    },
};

class ExtranetMenuAppBar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            auth: this.props.activeUser !== null,
            nbLogoClick: 0,
            anchorEl: null,
            sideMenuOpened: false,
        };

        this.props.getSynchroActiveUser(this.state, true);
    }

    componentDidMount() {
        this.props.loadLocationTitle();
    }

    openSideMenu() {
        this.setState({ sideMenuOpened: true });
    }

    closeSideMenu() {
        this.setState({ sideMenuOpened: false });
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (
            this.props.hideMenu !== nextProps.hideMenu ||
            this.props.locationTitle !== nextProps.locationTitle ||
            this.state.anchorEl !== nextState.anchorEl ||
            this.state.sideMenuOpened !== nextState.sideMenuOpened
        );
    }

    handleChange(event, checked) {
        this.setState({ auth: checked });
    }

    handleMenu(event) {
        this.setState({ anchorEl: event.currentTarget });
    }

    handleClose() {
        this.setState({ anchorEl: null });
    }

    goHome() {
        this.props.history.push("/");
    }

    logout() {
        this.props.clearUsers();
        this.props.history.push("/Login");
    }

    signout() {
        this.props.clearUsers();
        this.props.history.push("/Login");
    }

    synchronization() {
        this.props.synchronization(
            this.state,
            getStateAccessor(this.props),
            this.props.history,
            null,
            true
        );
    }

    goBack() {
        if (this.props.history.location.pathname.startsWith("/parks/park/componentPark"))
            this.props.history.push("/parks/park");
        else if (this.props.history.location.pathname.startsWith("/parks/park"))
            this.props.history.push("/parks");
        else if (this.props.history.location.pathname.startsWith("/parks"))
            this.props.history.push("/");
        else if (this.props.history.location.pathname.startsWith("/interventions/intervention"))
            this.props.history.push("/interventions");
        else if (this.props.history.location.pathname.startsWith("/affairs/affair"))
            this.props.history.push("/affairs");
        else if (this.props.history.location.pathname.split("/").length - 1 <= 1)
            this.props.history.push("/");
        else
            this.props.history.goBack();
    }

    onRestoreHomePageClick() {
        this.props.clearHiddenHomeWidgets(this.props.activeUser.id);
    }

    render() {
        const { classes } = this.props;
        const anchorEl = this.state.anchorEl;
        const open = Boolean(anchorEl);

        let locationTitle = this.props.locationTitle.toUpperCase();

        return (
            <div
                style={{
                    width: "100%",
                    height: "auto",
                    maxHeight: "15%",
                }}
            >
                <div className={"col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding " + (this.props.hideMenu ? "hide-sticky-menu" : "sticky-menu")}>
                    <AppBar className="topbar" position="static" color="primary">
                        <div className={"offset-xl-2 col-xl-10 offset-lg-3 col-lg-9 col-md-12 col-sm-12 col-12 without-side-padding "}>
                            <Toolbar
                                style={{
                                    minHeight: "68px",//hauteur du logo DFS
                                }}
                            >
                                <Hidden only={['xl', 'lg', 'md']}>
                                    <div className={"col-sm-1 col-2 " + (this.state.sideMenuOpened ? "hidden" : "")}>
                                        <IconButton
                                            color="inherit"
                                            aria-label="open drawer"
                                            onClick={this.openSideMenu.bind(this)}
                                            edge="start"
                                            className={(this.state.sideMenuOpened ? "hidden" : "")}
                                        >
                                            <MenuIcon />
                                        </IconButton>
                                    </div>
                                    {this.props.location.pathname !== "/" ? (
                                        <div className="row">
                                            <Button
                                                color="inherit"
                                                aria-label="Back"
                                                onClick={this.goBack.bind(this)}
                                                className="white_button col-lg-6 col-md-6 col-sm-6 col-6"
                                            >
                                                <ArrowBackIcon />
                                            </Button>
                                            <Button
                                                color="inherit"
                                                aria-label="Home"
                                                onClick={this.goHome.bind(this)}
                                                className="white_button col-lg-6 col-md-6 col-sm-6 col-6"
                                            >
                                                <HomeIcon />
                                            </Button>
                                        </div>
                                    ) : (
                                        <div></div>
                                    )}
                                </Hidden>
                                <div className="offset-lg-0 col-lg-10 offset-md-0 col-md-10 offset-sm-0 col-sm-10 offset-1 col-6">
                                    <div className="center">
                                        <Breadcrumbs location={locationTitle} />
                                    </div>
                                </div>
                                <Hidden only={['sm', 'xs']}>
                                    {this.state.auth && (
                                        <div className="offset-lg-1 col-lg-1 offset-md-1 col-md-2">
                                            <Button
                                                aria-owns={open ? "menu-appbar" : null}
                                                aria-haspopup="true"
                                                onClick={this.handleMenu.bind(this)}
                                                className="white_button"
                                            >
                                                <ProfileIcon fontSize="large" />
                                                <ExpandMore />
                                            </Button>
                                            <Menu
                                                id="menu-appbar"
                                                anchorEl={anchorEl}
                                                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                                                transformOrigin={{ vertical: "top", horizontal: "right" }}
                                                open={open}
                                                onClose={this.handleClose.bind(this)}
                                            >
                                                <div className="profile-menu">
                                                    <ListItemIcon className="user-icon" style={{ color: "#001A70" }}>
                                                        <ProfileIcon style={{ fontSize: 48 }} />
                                                    </ListItemIcon>
                                                    <GoogleLogout
                                                        clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
                                                        onLogoutSuccess={this.logout.bind(this)}
                                                        className="btn-logout logout-fab-btn"
                                                        icon={false}
                                                        buttonText="Déconnexion"
                                                        type="div"
                                                        tag="div"
                                                    >
                                                        <Fab size="small" style={{ color: "#F44336" }} onClick={this.signout.bind(this)} >
                                                            <FontAwesomeIcon title="Déconnexion" style={{ color: "#F44336" }} icon={faSignOutAlt} className="fa-lg" />
                                                        </Fab>
                                                    </GoogleLogout>
                                                    <Typography variant="h6" className="user-name">
                                                        {this.props.activeUser !== undefined
                                                            ? this.props.activeUser.name_related
                                                            : ""}
                                                    </Typography>
                                                </div>
                                                <MenuItem style={{ display: "flex", textAlign: "center" }} onClick={this.onRestoreHomePageClick.bind(this)}>
                                                    <ListItemIcon className={classes.icon} style={{ color: "#FE5815" }} >
                                                        <Icon>restore</Icon>
                                                    </ListItemIcon>
                                                    <Typography style={{
                                                        fontSize: 20,
                                                        color: "#005BBA",
                                                    }} >
                                                        {"Réinitialiser l'accueil"}
                                                    </Typography>
                                                </MenuItem>
                                            </Menu>
                                        </div>
                                    )}
                                </Hidden>
                            </Toolbar>
                        </div>
                    </AppBar>
                </div>
                <SideBar sideMenuOpened={this.state.sideMenuOpened} closeSideMenu={this.closeSideMenu.bind(this)}
                    openSideMenu={this.openSideMenu.bind(this)} >
                    <ExtranetSideBarContent />
                </SideBar>
            </div >
        );
    }
}

ExtranetMenuAppBar.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        locationTitle: state.locationTitle,
        activeUser: state.activeUser,
        synchro: state.synchro,
        parameter: state.parameter,
        hideMenu: state.layout.hideMenu,
        context: state.context,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        loadLocationTitle: () => dispatch(loadLocationTitle()),
        clearUsers: () => dispatch(clearUsers()),
        getSynchroActiveUser: (currentState, hideError) =>
            dispatch(ownProps.getSynchroActiveUser(currentState, hideError)),
        synchronization: (state, stateAccessor, history, interventionsFilters) =>
            dispatch(
                ownProps.synchronization(
                    state,
                    stateAccessor,
                    history,
                    interventionsFilters,
                    true
                )
            ),
        clearHiddenHomeWidgets: (userId) => dispatch(clearHiddenHomeWidgets(userId)),
    };
};

export default compose(
    withAuth,
    withStyles(styles),
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(ExtranetMenuAppBar);
